import type { JSX } from 'react';
import { Stack, Box, CircularProgress, Typography } from '@mui/material';

import Logo from '../components/logo';

interface LoadingPageProps {
	message?: string;
}

export default function LoadingPage({ message }: LoadingPageProps): JSX.Element {
	return (
		<>
			<Stack
				direction="column"
				spacing={32}
				sx={{
					justifyContent: 'center',
					alignItems: 'center',
					mt: 4,
				}}
			>
				<Box sx={{ '& img': { width: 216, height: 'auto' } }}>
					<Logo />
				</Box>

				<Box display="flex" flexDirection="column" alignItems="center">
					<CircularProgress size={64} sx={{ color: 'brand.main' }} />
					<Typography variant="h6" sx={{ mt: 4 }}>
						Just a moment...
					</Typography>
					<Typography variant="h6">{message}</Typography>
				</Box>
			</Stack>
		</>
	);
}
